export type SelectMode = 'transfer' | 'compare';

/**
 * The total number of cells that each row has. This is useful if you wan't to render
 * content which spans all/multiple cells (e.g. the loading bars).
 */
export const COLUMN_COUNT = 13;
